import ProfileShimmer from "../../components/common/ShimmerEffect/ProfileShimmer";
import { formatMessageData, getLastMessageText } from "../../components/common/GetParsedMessage";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectedConversation, updateTimeLine } from "../../state/actions/chats";

const ConnectSidebar = ({
    handleFilterChange,
    activeFilter,
    unReadCount,
    favouriteCount,
    groupsCount,
    timeLine,
    searchInput,
    avatarMap,
    selectedContact,
    setSelectedContact,
    handleChatItemClick,
    isShimmerLoading,
    activeMessageChatAreaDetail,
    selectedChatFilter,
}) => {
    const [onTopConversationId, setOnTopConversationId] = useState(null);
    const activeMessageChatArea = useSelector((state) => state.chats.activeMessageChatArea);
    const dispatch = useDispatch();


    //Update last messge in list from chatbot script
    window.sendFirstMessage = function (messageData) {
        // console.log("First message from chatbot script:", messageData, activeMessageChatAreaDetail,timeLine);
        if (!messageData) return;

        setOnTopConversationId(messageData);
        const formattedMessage = formatMessageData(messageData);

        for (let i in timeLine) {
            if (activeMessageChatAreaDetail?.channelId && timeLine[i].channel) {
                if (activeMessageChatAreaDetail.channelName === timeLine[i].channel?.channelName) {
                    timeLine[i].lastMessage = formattedMessage;
                    timeLine[i].contentType = formattedMessage.contentType;
                    timeLine[i].createdOn = formattedMessage.createdOn;
                    timeLine[i].modifiedOn = formattedMessage.createdOn;
                }
            }
            else if (activeMessageChatAreaDetail?.contact && timeLine[i].contact) {
                if (activeMessageChatAreaDetail.conversationId === timeLine[i].conversationId) {
                    timeLine[i].lastMessage = formattedMessage;
                    timeLine[i].contentType = formattedMessage.contentType;
                    timeLine[i].createdOn = formattedMessage.createdOn;
                    timeLine[i].modifiedOn = formattedMessage.createdOn;
                }
            }
        }
        dispatch(updateTimeLine(timeLine));
    };

    const uniqueTimeline = Object.values(
        timeLine.reduce((acc, conv) => {
            if (!acc[conv.conversationId]) {
                acc[conv.conversationId] = conv; // keep the first one
            }
            return acc;
        }, {})
    );

    return (
        <>
            <div className="flex justify-between px-2 mb-2 text-xs text-gray-600">
                <button
                    className={`flex-1 py-1 mx-1 rounded-full h-[34px] text-size-14 ${activeFilter === 'all'
                        ? 'bg-[#638DFF] text-white'
                        : 'border border-[#638DFF] hover:bg-[#638DFF] text-[#638DFF] hover:text-white'
                        }`}
                    onClick={() => handleFilterChange('all')}
                >
                    All
                </button>
                <button
                    className={`flex-1 py-1 mx-1 rounded-full h-[34px] text-size-14 ${activeFilter === 'unread'
                        ? 'bg-[#638DFF] text-white'
                        : 'border border-[#638DFF] hover:bg-[#638DFF] text-[#638DFF] hover:text-white'
                        }`}
                    onClick={() => handleFilterChange('unread')}
                >
                    Unread <span>{unReadCount}</span>
                </button>
                <button
                    className={`flex-1 py-1 mx-1 rounded-full h-[34px] text-size-14 ${activeFilter === 'favorites'
                        ? 'bg-[#638DFF] text-white'
                        : 'border border-[#638DFF] hover:bg-[#638DFF] text-[#638DFF] hover:text-white'
                        }`}
                    onClick={() => handleFilterChange('favorites')}
                >
                    Favorites <span>{favouriteCount}</span>
                </button>
                <button
                    className={`flex-1 py-1 mx-1 rounded-full h-[34px] text-size-14 ${activeFilter === 'groups'
                        ? 'bg-[#638DFF] text-white'
                        : 'border border-[#638DFF] hover:bg-[#638DFF] text-[#638DFF] hover:text-white'
                        }`}
                    onClick={() => handleFilterChange('groups')}
                >
                    Groups <span>{groupsCount}</span>
                </button>
            </div>
            <div className="flex-1 h-[calc(100vh-120px)] overflow-y-auto">
                {isShimmerLoading ?
                    Array.from({ length: 5 }).map((_, index) => (
                        <ProfileShimmer key={index} index={index} />
                    ))
                    :
                    uniqueTimeline
                        .filter((conv) => {
                            if (activeFilter === 'groups') return conv.channel;
                            if (activeFilter === 'unread') return conv.unreadCount;
                            if (activeFilter === 'favorites') return conv.favourite;
                            return true;
                        })
                        .filter((conv) => {
                            const name = conv?.contact?.userName || conv?.channel?.channelName || '';
                            return name.toLowerCase().includes(searchInput.toLowerCase());
                        }).sort((a, b) => {
                            // Sort by modifiedOn (latest first)
                            const aTime = a.modifiedOn ? new Date(a.modifiedOn).getTime() : 0;
                            const bTime = b.modifiedOn ? new Date(b.modifiedOn).getTime() : 0;

                            if (aTime !== bTime) return bTime - aTime;

                            // Fallback alphabetical
                            const aName = a?.contact?.userName || a?.channel?.channelName || "";
                            const bName = b?.contact?.userName || b?.channel?.channelName || "";
                            return aName.localeCompare(bName);
                        })
                        .map((conv, idx) => {

                            const name =
                                conv?.contact?.userName ||
                                conv?.channel?.channelName ||
                                "Unnamed";
                            const avatar = avatarMap[conv.conversationId] || "";

                            const time = conv?.modifiedOn
                                ? new Date(conv.modifiedOn).toLocaleTimeString([], {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                })
                                : "";

                            const isActive =
                                (conv?.conversationId === selectedContact?.conversationId && activeMessageChatArea) ||
                                (conv?.contact && conv.contact?.userId === selectedContact?.contact?.userId && activeMessageChatArea) ||
                                (conv?.channel && conv.conversationId === selectedContact?.channelId && activeMessageChatArea);

                            const classes = `cursor-pointer flex items-center space-x-2 rounded-lg transition-colors
                                             ${isActive ? "bg-gray-100" : "bg-gray-500 hover:bg-gray-100"} p-2 mb-3 mt-3`;


                            if (conv.contact || conv.channel) {
                                return (
                                    <div
                                        key={conv.conversationId}
                                        className={classes}
                                        onClick={() => {
                                            const isSameContact =
                                                conv?.contact?.userId &&
                                                selectedContact?.contact?.userId === conv?.contact?.userId;

                                            const isSameChannel =
                                                conv?.channel?.channelName &&
                                                selectedContact?.channelName === conv?.channel?.channelName;

                                            if ((isSameContact || isSameChannel) && selectedChatFilter === activeFilter) {
                                                return;
                                            } else {
                                                setSelectedContact(null);
                                                dispatch(clearSelectedConversation());
                                                handleChatItemClick(conv)
                                            }
                                        }}
                                    >
                                        {!avatar ? (
                                            <div className="w-[45px] h-[45px] rounded-full bg-gray-300 animate-pulse" />
                                        ) : avatar.startsWith("http") || avatar.startsWith("blob:") ? (
                                            <img
                                                src={avatar}
                                                alt="Avatar"
                                                className="rounded-full w-[45px] h-[45px] object-cover"
                                            />
                                        ) : (
                                            <div className="rounded-full bg-primary-blue w-[45px] h-[45px] bg-gray-500 flex items-center justify-center text-white text-sm font-[Figtree]">
                                                {avatar}
                                            </div>
                                        )}
                                        <div className="flex-1 overflow-hidden">
                                            <div className="font-bold text-size-14 text-[#15194B] truncate">
                                                {name}
                                            </div>
                                            <div className="text-[#15194B] text-size-14 truncate w-[200px] font-normal">
                                                {/* {typeof parsedHtml !== "object" && parsedHtml !== null ? parsedHtml : ""} */}
                                                {getLastMessageText(conv?.lastMessage)}
                                            </div>
                                        </div>
                                        <div className="text-right">
                                            {time && (
                                                <div className="text-size-13 text-[#5F5F5F] mb-1">{time}</div>
                                            )}
                                            {conv.unreadCount > 0 && (
                                                <div className="bg-[#00CD26] text-white text-size-13 rounded-full px-2 h-[20px] w-[20px] flex justify-center items-center ml-auto">
                                                    {conv.unreadCount}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            }

                            return null;
                        })}
            </div>
        </>
    )
}
export default ConnectSidebar;